import Web3 from 'web3'

export const web3Contract = async (abi: any, contractAddress: string) => {
  const web3 = new Web3(Web3.givenProvider)

  const ct = new web3.eth.Contract(abi as any, contractAddress)
  return ct

  // if (forceProvider) {
  //   const web3 = new Web3(Web3.givenProvider)

  //   const ct = new web3.eth.Contract(abi as any, contractAddress)
  //   return ct
  // } else {
  //   const RPC_URL = getNodeUrl()
  //   const web3 = new Web3(RPC_URL)
  //   const ct = new web3.eth.Contract(abi as any, contractAddress)
  //   return ct
  // }
}
